import React, { createContext, useContext, useState, useEffect } from "react"
import Model, { Store } from "../../model/model"
import Hub from "../../hub"
import Sync from "../../sync/sync"
import { PlateView } from "../../plate_viewer"
import Local from "../../sync/local"
import Commander from "../../model/commander"

type Nana = {
  model: Model
  commander: Commander
  hub: Hub
  sync: Sync
  local: Local
  plateView: PlateView | null
  setPlateView: (plateView: PlateView | null) => void
  initialLoadComplete: boolean
}

const createNana = () => {
  const hub = new Hub()
  const model = new Model(new Store())

  const commander = new Commander()
  commander.model = model
  commander.hub = hub

  const sync = new Sync()
  sync.model = model
  sync.hub = hub
  sync.attachToCommander(commander)

  const local = new Local()
  local.model = model
  local.attachToHub(hub)

  return {
    model,
    commander,
    hub,
    sync,
    local,
    plateView: null,
    setPlateView: () => {},
    initialLoadComplete: false,
  }
}

const NanaContext = createContext<Nana>(createNana())

export const NanaProvider = ({ children }) => {
  const [nana, setNana] = useState<Nana>(createNana())

  ;(window as any).Nana = nana

  const setPlateView = (plateView: PlateView | null) => {
    setNana((nana) => ({ ...nana, plateView }))
  }

  useEffect(() => {
    nana.sync.fetchAll(() => {
      nana.model.hub = nana.hub
      nana.sync.startPolling()
      setNana({ ...nana, initialLoadComplete: true, setPlateView })
    })
  }, [])

  return <NanaContext.Provider value={nana}>{children}</NanaContext.Provider>
}

export const useNana = () => {
  return useContext(NanaContext)
}
